import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from './FormControl.js';
import FormLabel from 'react-bootstrap/FormLabel';
import { RadioGroup, Stack } from '@chakra-ui/react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { i18n } from '../../../i18n/translate.js';
import kebabCase from 'lodash/kebabCase.js';
import { SelectionLabel } from '../../../core/components/SelectionControl/label.js';
import { FAIcon } from '../../fa-icon/component.js';
import { Checkbox } from './Checkbox/component.js';

var RadioGroupControl = /*#__PURE__*/function (_FormControl) {
  function RadioGroupControl(props) {
    var _this;

    _classCallCheck(this, RadioGroupControl);

    _this = _callSuper(this, RadioGroupControl, [props]);

    _defineProperty(_this, "onClick", function (value) {
      _this.setState({
        value: value
      });

      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    });

    _defineProperty(_this, "toggleShowMore", function () {
      _this.setState({
        showMoreValues: !_this.state.showMoreValues
      });
    });

    _this.state = {
      showMoreValues: !props.truncateSize,
      value: props.dataValue
    };
    return _this;
  }

  _inherits(RadioGroupControl, _FormControl);

  return _createClass(RadioGroupControl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          valueList = _this$props.valueList,
          truncateSize = _this$props.truncateSize,
          valueKey = _this$props.valueKey,
          labelKey = _this$props.labelKey,
          inline = _this$props.inline,
          name = _this$props.name;

      if (!valueList) {
        return;
      }

      var showMoreValues = this.state.showMoreValues;
      var truncatedValueList = showMoreValues || !truncateSize ? valueList : valueList.slice(0, truncateSize);
      return /*#__PURE__*/React.createElement("div", null, this.props.controlLabelText && /*#__PURE__*/React.createElement(FormLabel, null, this.props.controlLabelText), this.props.tooltip && /*#__PURE__*/React.createElement(OverlayTrigger, {
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, null, this.props.tooltip)
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FAIcon, {
        icon: "circle-question",
        additionalClasses: "p-l-5"
      }))), /*#__PURE__*/React.createElement(RadioGroup, {
        onChange: this.onClick,
        name: name,
        defaultValue: String(this.state.value)
      }, /*#__PURE__*/React.createElement(Stack, {
        spacing: inline ? 4 : 1,
        direction: inline ? 'row' : 'column'
      }, truncatedValueList.map(function (item) {
        return /*#__PURE__*/React.createElement(Checkbox, {
          "data-object-action": "select-".concat(kebabCase(item[labelKey])),
          isDisabled: disabled,
          key: String(item[valueKey]),
          type: "radio",
          value: String(item[valueKey])
        }, /*#__PURE__*/React.createElement(SelectionLabel, {
          label: item[labelKey]
        }));
      }), truncateSize < valueList.length ? /*#__PURE__*/React.createElement("div", {
        className: "show-more-link"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.toggleShowMore
      }, this.state.showMoreValues ? i18n.t('Show Less') : i18n.t('Show More'))) : null)));
    }
  }]);
}(FormControl);

_defineProperty(RadioGroupControl, "propTypes", {
  name: PropTypes.string.isRequired,
  valueList: PropTypes.array.isRequired,
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  dataValue: PropTypes.string,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  truncateSize: PropTypes.number,
  controlLabelText: PropTypes.string,
  tooltip: PropTypes.string,
  inline: PropTypes.bool
});

_defineProperty(RadioGroupControl, "defaultProps", {
  dataValue: '',
  inline: false
});

RadioGroupControl.displayName = "RadioGroupControl";
export { RadioGroupControl };